import { type FC, useContext, useEffect } from 'react';
import useMeasure from 'react-use-measure';
import cn from 'classnames';

// import { NotificationIcon } from '@components/ui/NotificationIcon/NotificationIcon';
import { AppRoute } from '@/common/app/routes';
import { useCheckVIPstatus } from '@/common/hooks/checkVIPstatus';
import { useMatchPath } from '@/common/hooks/match-path';
import { convertRemToPixels } from '@/common/lib/convertRemtoPx';
import { setCssVar } from '@/common/lib/cssVar';

// import { useAppSelector } from '@/redux/store';
import { UserBasicInfo } from '../common/UserBasicInfo/UserBasicInfo';
import { ModalContext } from '../Modals/Modal/config';

import logoVip from '/img/white-gold-logo.png';
import logoDefault from '/img/white-green-logo.png';

const Header: FC = () => {
  const [headerRef, headerRect] = useMeasure();
  const statusVIP = useCheckVIPstatus();
  const isLeauguePage = useMatchPath([AppRoute.LEAGUES]);
  const isUrlHasBlurHeader = useMatchPath([AppRoute.WORKSHOP, AppRoute.EARN]);
  const { headerVisible } = useContext(ModalContext);
  // const headerHasBlur = useAppSelector((state) => state.app.headerHasBlur);

  useEffect(() => {
    if (headerRect.height && headerRect.width) {
      setCssVar('--header-height', `${headerRect.bottom}px`);
    }
  }, [headerRect]);

  return (
    <header
      ref={headerRef}
      className={cn(
        'logo-header',
        {
          'back-blur': isUrlHasBlurHeader,
          'z-[99999]': headerVisible,
        },
        isLeauguePage && 'bg-main-bg',
      )}
    >
      <img
        className="logo"
        src={statusVIP ? logoVip : logoDefault}
        alt="logo"
        width={convertRemToPixels(3.844375)}
      />
      <UserBasicInfo />
    </header>
  );
};

export default Header;
